import { Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Typography } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close'
import { formatDateHourMinute } from "../../utils/strings"

export interface ParticipanteI {
    id: number
    nombreProfesor: string
    email: string
    edad: string
    ciudad: string
    puesto: string
    nivelEducativo: string
    comoSeEntero: string
    interes: string
    codigoRegistro: string
    fechaAsistencia: string
    fechaAlta: string
}

interface Props {
    participante: ParticipanteI | null
    onClose: () => void
}

const Field = ({ label, value }: { label: string; value: string }) => (
    <Grid item xs={12} sm={6}>
        <Typography variant="caption" color="text.secondary">{label}</Typography>
        <Typography variant="body1">{value || '—'}</Typography>
    </Grid>
)

const ParticipanteModal = ({ participante, onClose }: Props) => {
    if (!participante) return null

    return (
        <Dialog open={!!participante} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {participante.nombreProfesor}
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Grid container spacing={2} sx={{ mt: 0.5 }}>
                    <Field label="Código de registro" value={participante.codigoRegistro} />
                    <Field label="Email" value={participante.email} />
                    <Field label="Edad" value={participante.edad} />
                    <Field label="Ciudad" value={participante.ciudad} />
                    <Field label="Puesto" value={participante.puesto} />
                    <Field label="Nivel educativo" value={participante.nivelEducativo} />
                    <Field label="¿Cómo se enteró?" value={participante.comoSeEntero} />
                    <Field label="Interés" value={participante.interes} />
                    <Field label="Fecha de asistencia" value={participante.fechaAsistencia ? formatDateHourMinute(participante.fechaAsistencia) : '—'} />
                    <Field label="Fecha de registro" value={participante.fechaAlta ? formatDateHourMinute(participante.fechaAlta) : '—'} />
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

export default ParticipanteModal
